export const getFieldDropdownOptions = (count: number, options: Array<string>): string[] => {
    for (let i = 1; i <= count; i++) {
        options.push(`${i} по порядку`);
    }
    return options;
};
